import {RsDocumentTemplate} from "./dto/RsDocumentTemplate";
import {getUserInfo} from "./APIUtils";
import {AxiosResponse} from "axios";
import {Response} from "./dto/Response";
import {RsDocumentTemplateGroup} from "./dto/RsDocumentTemplateGroup";
import apiJson from "../config/api-json";

export class DocumentTemplateAPI {

    baseUrl: string = "/retrieve-document-template"

    async retrieveDocumentTemplateByGroup(groupId: string, verificationId: string): Promise<RsDocumentTemplate[]> {
        let token = localStorage.getItem("next-step")
        const config = await getUserInfo(verificationId, token)
        const response: AxiosResponse<Response<RsDocumentTemplateGroup[]>> = await apiJson.get(
            `${this.baseUrl}/group/${groupId}`,
            config
        )
        if (response.status !== 200) {
            throw new Error(`DocumentTemplateAPI retrieveDocumentTemplateByGroup: ${response.statusText}`)
        }
        return response.data.data
    }

}